import * as React from 'react';
import { Suspense, lazy } from 'react';

import { LoadingSpinner } from '../loading-spinner';

const InteriorView360 = lazy(async () => import(/* webpackChunkName: "interior" */ './interior-view-360'));

export default function InteriorRender() {
	return (
		<Suspense fallback={<LoadingSpinner />}>
			<InteriorView360 />
		</Suspense>
	);
}
